import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Image {
  uuid?: string;
  url: string;
  name?: string;
  index: number;
  description?: string;
  createdAt?: Date | string;
}
interface entity {
  name: string;
  uuid: string;
}

export interface Image {
  index: number;
  description?: string;
  url: string;
}

export interface PayloadUpload {
  files: File[];
  entity: string;
  objectUuid: string;
  descriptions?: string[];
}
@Injectable({
  providedIn: 'root',
})
export class PhotosService {
  private api = environment.WO_API_URL;

  constructor(private http: HttpClient) {}

  getImageUrl(file: string, entityName: string, entityUuid: string) {
    return `${environment.AZURE_URI}/${entityName}/${entityUuid}/${file}`;
  }

  list(objectUuid: string) {
    const access_token = localStorage.getItem('access_token') ?? '';

    return this.http.get<Image[]>(`${this.api}/photos/${objectUuid}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  listByEntityNameAndObjectUuid(
    entityName: string | undefined,
    objectUuid: string,
  ) {
    const access_token = localStorage.getItem('access_token') ?? '';

    return this.http.get<Image[]>(
      `${this.api}/photos/${entityName}/${objectUuid}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }

  upload(payload: PayloadUpload) {
    const formData = new FormData();

    payload.files.forEach((file, index) => {
      formData.append('files', file);
      if (payload.descriptions?.[index]) {
        formData.append('descriptions[]', payload.descriptions[index]);
      }
    });

    formData.append('entity', payload.entity);
    formData.append('objectUuid', payload.objectUuid);

    const access_token = localStorage.getItem('access_token') ?? '';

    return this.http.post(`${this.api}/photos/upload/`, formData, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  update(updatedPhotos: Image[]) {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.patch(`${this.api}/photos/update/`, updatedPhotos, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  delete(entity: entity, fileName: string): Observable<any> {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.delete(
      `${this.api}/photos/${entity.name}/${entity.uuid}/${fileName}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }

  getImageName(url: string): string {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url);
      const fileName = parsedUrl.pathname.split('/').pop() ?? '';
      return decodeURIComponent(fileName);
    } catch {
      return decodeURIComponent(url.split('/').pop()?.split('?')[0] ?? '');
    }
  }
}

// OLD CODE (WITH BASE64)

// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
// import { PhotoPreview } from 'src/assets/types/interface/photo-preview.interface';
// import { environment } from 'src/environments/environment';

// @Injectable({
//   providedIn: 'root',
// })
// export class PhotosService {
//   private readonly apiUrlCompany = environment.COMPANY_API_URL;
//   private readonly apiUrlOS = environment.WO_API_URL;

//   constructor(private http: HttpClient) {}

//   setServicePhotos(companyUuid: string, serviceUuid: string, data: any) {
//     const access_token = localStorage.getItem('access_token') ?? '';
//     return this.http.post<any[]>(
//       `${this.apiUrlCompany}/photos/service/${serviceUuid}/company/${companyUuid}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//         },
//       },
//     );
//   }

//   getServicePhotos(serviceUuid: string) {
//     const access_token = localStorage.getItem('access_token') ?? '';
//     return this.http.get(
//       `${this.apiUrlCompany}/photos/service/${serviceUuid}`,
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//         },
//       },
//     );
//   }

//   deleteServicePhoto(fileUuid: string) {
//     const access_token = localStorage.getItem('access_token') ?? '';
//     return this.http.delete(`${this.apiUrlCompany}/photos/${fileUuid}`, {
//       headers: {
//         Authorization: `Bearer ${access_token}`,
//       },
//     });
//   }

//   setEnvironmentPhotos(environmentUuid: string, data: any) {
//     const access_token = localStorage.getItem('access_token');
//     return this.http.post<any[]>(
//       `${this.apiUrlOS}/photos/environment/${environmentUuid}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//         },
//       },
//     );
//   }

//   setEquipmentPhotos(equipmentUuid: string, data: any) {
//     const access_token = localStorage.getItem('access_token');
//     return this.http.post<any[]>(
//       `${this.apiUrlOS}/photos/equipment/${equipmentUuid}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//         },
//       },
//     );
//   }

//   getPhotos(fileUuid: string): Observable<PhotoPreview[]> {
//     const access_token = localStorage.getItem('access_token');
//     return this.http.get<PhotoPreview[]>(
//       `${this.apiUrlOS}/photos/${fileUuid}`,
//       {
//         headers: {
//           Authorization: `Bearer ${access_token}`,
//         },
//       },
//     );
//   }

//   deleteOsPhoto(fileUuid: string) {
//     const access_token = localStorage.getItem('access_token');
//     return this.http.delete(`${this.apiUrlOS}/photos/${fileUuid}`, {
//       headers: {
//         Authorization: `Bearer ${access_token}`,
//       },
//     });
//   }
// }
